import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/cloud-cost/cloud_cost_efficiency.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={5}
            xxl={6}
            className="cloud_cost_extra"
          >
            <h2>
              Transform Your Cloud Efficiency by Taking{" "}
              <span>Control of Your Cloud Costs</span>
            </h2>
            <p>Connect with Our Team for Quick Insights</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
